export const searchData = 'SEARCHDATA';

export const setSearchData = (data) => {  
	
  return { 
  		type: searchData, 
  		dataForSearch: data 
  	}
}


// WEBPACK FOOTER //
// ./src/actions/search.js